import { faThumbtack } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bulma-components";

type Props = {
    isFocused: boolean;
    setFocused: (focus: boolean) => void;
};

export default function FocusButton({ isFocused, setFocused }: Props) {
    return (
        <Button
            style={{
                backgroundColor: isFocused ? "#3e56c4" : "rgba(0, 0, 0, 0.5)",
                borderRadius: 14,
                border: "none"
            }}
            onClick={() => setFocused(!isFocused)}>
            {isFocused && (
                <span style={{ color: "white", paddingRight: 10 }}>Pinned</span>
            )}
            <FontAwesomeIcon icon={faThumbtack} color="white" />
        </Button>
    );
}
